/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './events.scss';

/* eslint-disable import/no-unresolved, import/default */

import eventsTemplate from './events.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.event.events', [])
    .directive('tkEvents', Events)
    .name;

/*@ngInject*/
function Events() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            entityId: '=',
            allAlarms: '=?'
        },
        controller: EventsController,
        controllerAs: 'vm',
        templateUrl: eventsTemplate
    };
}

/*@ngInject*/
function EventsController($rootScope, $scope, $state, userService, eventService, gatewayService, deviceService, integrationService, $filter, $translate, $mdMedia, types) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.allEvents = [];
        vm.events = [];
        vm.rowsCount = 0;

        vm.query = {
            order: '-startTs',
            limit: 15,
            page: 1,
            search: null
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.reload = reload;

        vm.onReorder = function () {
            updateEvents();
        };

        vm.onPaginate = function () {
            updateEvents();
        };

        vm.enterFilterMode = function () {
            vm.query.search = '';
        };

        vm.exitFilterMode = function () {
            vm.query.search = null;
            updateEvents();
        };

        vm.loading = function () {
            return $rootScope.loading;
        };

        vm.displayOpenDetails = displayOpenDetails;
        vm.openEntityDetails = openEntityDetails;
        vm.getLabel = getLabel;
        vm.getLabelIcon = getLabelIcon;

        resetFilter();
    };

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.entityId', (newVal) => {
        if (newVal) {
            resetFilter();
            reload();
        }
    });

    $scope.$watch('vm.allAlarms', (newVal) => {
        if (newVal) {
            resetFilter();
            reload();
        }
    });

    $scope.$watch("vm.eventType", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reload();
        }
    });

    $scope.$watch("vm.eventTypes", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reload();
        }
    });

    $scope.$watch("vm.timewindow", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reload();
        }
    }, true);

    $scope.$watch("vm.query.search", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateEvents();
        }
    });

    function resetFilter() {
        vm.query.search = null;
        vm.timewindow = {
            history: {
                timewindowMs: 24 * 60 * 60 * 1000 // 1 day
            }
        };
        if (vm.allAlarms) {
            vm.eventTypes = [];
        } else {
            vm.eventType = types.eventType.ALARM.value;
        }
    }

    function reload() {
        vm.allEvents.length = 0;
        vm.events.length = 0;
        vm.rowsCount = 0;
        var startTs;
        var endTs;
        if (vm.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            startTs = currentTime - vm.timewindow.history.timewindowMs;
            endTs = null;
        } else {
            startTs = vm.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.timewindow.history.fixedTimewindow.endTimeMs;
        }
        if (vm.allAlarms) {
            vm.eventsPromise = eventService.getAllEvents(vm.eventTypes, startTs, endTs);
        } else {
            vm.eventsPromise = eventService.getEntityEvents(vm.entityId.entityType, vm.entityId.id, vm.eventType, startTs, endTs);
        }
        vm.eventsPromise.then(
            (events) => {
                vm.allEvents = events;
                vm.allEvents.forEach((event) => {
                    event.severityText = $translate.instant(vm.types.severity[event.severity].name);
                    event.stateText = $translate.instant(vm.types.eventState[event.state].name);
                    event.entityTypeName = $translate.instant(vm.types.entityTypeTranslations[event.entityId.entityType].name);
                    event.typeName = $translate.instant(vm.types.eventType[event.type].typeName);
                });
                updateEvents();
            },
            () => {
                updateEvents();
            }
        );
    }

    function updateEvents() {
        var result = $filter('orderBy')(vm.allEvents, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.rowsCount = result.length;
        var startIndex = vm.query.limit * (vm.query.page - 1);
        vm.events = result.slice(startIndex, startIndex + vm.query.limit);
    }

    function displayOpenDetails(event) {
        var authority = userService.getAuthority();
        if (authority == types.authority.PROVIDER_ADMIN.value) {
            return event.entityId.entityType == types.entityType.gateway;
        } else {
            return true;
        }
    }

    function getLabel($event, event) {
        if (event.entityId.entityType == vm.types.entityType.gateway) {
            return $translate.instant('event.gateway-details');
        } else if (event.entityId.entityType == vm.types.entityType.device) {
            return $translate.instant('event.device-details');
        } else if (event.entityId.entityType == vm.types.entityType.integration) {
            return $translate.instant('event.integration-details');
        } else {
            return $translate.instant('event.label');
        }
    }

    function getLabelIcon($event, event) {
        if (event.entityId.entityType == vm.types.entityType.gateway) {
            return 'router';
        } else if (event.entityId.entityType == vm.types.entityType.device) {
            return 'devices_other';
        } else if (event.entityId.entityType == vm.types.entityType.integration) {
            return 'extension';
        } else {
            return 'memory';
        }
    }

    function openEntityDetails($event, event) {
        var entityId = event.entityId;
        if (entityId.entityType == types.entityType.gateway) {
            gatewayService.getGateway(entityId.id).then(
                (gateway) => {
                    $state.go('home.gatewayGroups.gateways', {gatewayGroupId: gateway.gatewayGroupId.id, entityId: entityId});
                }
            );
        } else if (entityId.entityType == types.entityType.device) {
            deviceService.getDevice(entityId.id).then(
                (device) => {
                    $state.go('home.applications.devices', {applicationId: device.applicationId.id, entityId: entityId});
                }
            );
        } else if (entityId.entityType == types.entityType.integration) {
            integrationService.getIntegration(entityId.id).then(
                (integration) => {
                    $state.go('home.applications.integrations',
                        {applicationId: integration.applicationId.id, entityId: integration.id, entityIdIntegration: entityId});
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/event/events.directive.js